module.exports = __webpack_public_path__ + "img/lucia.1bc77b4d.png";